import React, { memo } from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Section Header Component
 * Provides consistent styling for section headers
 */
const SectionHeader = memo(({ title, subtitle, className = '' }) => (
    <div className={`position-relative d-flex text-center mb-4 ${className}`}>
        <h2 className="text-22 text-light opacity-4 text-uppercase fw-600 w-100 mb-0 font-primary wow fadeInUp">
            {title}
        </h2>
        <p className="text-10 text-dark fw-600 position-absolute w-100 align-self-center font-secondary lh-base mb-0 wow fadeInUp">
            {subtitle}
        </p>
    </div>
));

SectionHeader.displayName = 'SectionHeader';

SectionHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default SectionHeader;